import React, { useMemo } from 'react';
import { css, cx } from 'react-emotion';
import FilterablePage from '../Layout/FilterablePage/FilterablePage';
import { theme } from '../Theme';
import { eztradStyling } from './EztradStyling';
import useShopId from '../../utils/useShopId';
import { Redirect } from 'react-router-dom';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import {
  Heading,
  Subheading,
  MaxWidth
} from '../ContentPage/ContentComponents';
import DynamicContentWrapper from '../ContentPage/DynamicContentWrapper';

const containerStyling = css`
  .items-container {
    margin: 4.125rem 0 6.125rem;
    h2 {
      margin-bottom: 2rem;

      font-weight: 700;
      font-size: 1.875rem;
      letter-spacing: 0.01em;
      color: ${theme.colors.green};
    }
    .content-container *:first-child {
      margin-top: 0;
    }
  }
  ${theme.below.md} {
    .items-container {
      margin-top: 2.625rem;
      h2 {
        font-size: 1.5rem;
      }
      h3 {
        font-size: 1rem;
      }
    }
  }
`;

const supportComponents = {
  heading: props => <Heading Tag="h3" {...props} />,
  subheading: props => <Subheading Tag="h4" {...props} />
};

const ItemComponent = ({ content, name }) => (
  <div>
    <MaxWidth>
      <h2>{name}</h2>
    </MaxWidth>
    <div className="content-container">
      <DynamicContentWrapper
        content={content}
        additionalComponents={supportComponents}
      />
    </div>
  </div>
);

const SupportPage = ({ category, cacheHit, result }) => {
  const isEztrad = useShopId() === 'eztrad';
  const { pageIds } = useShopConfig();
  const subcategories = category.parent?.subcategories || [];

  const { itemList, buttonList, defaultActiveKey } = useMemo(() => {
    const itemList = [];
    const buttonList = [];
    const defaultActiveKey = category.id;

    subcategories.forEach(({ name, content, primaryRoute, id }) => {
      buttonList.push({ key: id, buttonText: name, path: primaryRoute.path });
      itemList.push({
        key: id,
        Item: () => <ItemComponent content={content} name={name} />
      });
    });
    return { itemList, buttonList, defaultActiveKey };
  }, [subcategories, category.id]);

  if (category.id === parseInt(pageIds.support))
    return <Redirect to={category.subcategories[0].primaryRoute.path} />;

  return (
    <FilterablePage
      pageHeaderProps={{
        title: category.name,
        parents: result.data?.route?.parents || null,
        breadcrumbText: category.breadcrumbText
      }}
      itemList={itemList}
      buttonList={buttonList}
      areButtonsLinks={true}
      defaultActiveKey={defaultActiveKey}
      cacheHit={cacheHit}
      isMobileDropdown
      className={
        isEztrad ? cx(containerStyling, eztradStyling) : containerStyling
      }
    />
  );
};

export default SupportPage;
